import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ContactUsComponent } from "../../contact-us/contact-us.component";
import { TestimonialsComponent } from "../../testimonials/testimonials.component";
import { BoardingFilterComponent } from "./boarding-filter/boarding-filter.component";
import { HomePlanComponent } from "./home-plan/home-plan.component";
import { Utils } from "src/app/shared/utils";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    BoardingFilterComponent,
    HomePlanComponent,
    TestimonialsComponent,
    ContactUsComponent,
  ],
  providers: [Utils],
})
export class HomeComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    sessionStorage.removeItem("groomingFilter");
  }
}
